module.exports = __webpack_public_path__ + "static/media/video.314d04d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/video.mp4
// module id = 43
// module chunks = 0